// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/a2ui/v1/a2ui.proto" (package "c1.api.a2ui.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { A2UIService } from "./a2ui";
import type { A2UIServiceListSurfaceFeedbackResponse } from "./a2ui";
import type { A2UIServiceListSurfaceFeedbackRequest } from "./a2ui";
import type { A2UIServiceCreateSurfaceFeedbackResponse } from "./a2ui";
import type { A2UIServiceCreateSurfaceFeedbackRequest } from "./a2ui";
import type { A2UIServiceListSurfacesResponse } from "./a2ui";
import type { A2UIServiceListSurfacesRequest } from "./a2ui";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { A2UIServiceSubmitActionResponse } from "./a2ui";
import type { A2UIServiceSubmitActionRequest } from "./a2ui";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * A2UIService provides operations for A2UI surfaces.
 *
 * @generated from protobuf service c1.api.a2ui.v1.A2UIService
 */
export interface IA2UIServiceClient {
    /**
     * SubmitAction handles user actions on A2UI surfaces.
     *
     * @generated from protobuf rpc: SubmitAction
     */
    submitAction(input: A2UIServiceSubmitActionRequest, options?: RpcOptions): UnaryCall<A2UIServiceSubmitActionRequest, A2UIServiceSubmitActionResponse>;
    /**
     * ListSurfaces returns active surfaces for a conversation.
     *
     * @generated from protobuf rpc: ListSurfaces
     */
    listSurfaces(input: A2UIServiceListSurfacesRequest, options?: RpcOptions): UnaryCall<A2UIServiceListSurfacesRequest, A2UIServiceListSurfacesResponse>;
    /**
     * CreateSurfaceFeedback submits feedback for a surface with a snapshot.
     *
     * @generated from protobuf rpc: CreateSurfaceFeedback
     */
    createSurfaceFeedback(input: A2UIServiceCreateSurfaceFeedbackRequest, options?: RpcOptions): UnaryCall<A2UIServiceCreateSurfaceFeedbackRequest, A2UIServiceCreateSurfaceFeedbackResponse>;
    /**
     * ListSurfaceFeedback lists feedback for a surface.
     *
     * @generated from protobuf rpc: ListSurfaceFeedback
     */
    listSurfaceFeedback(input: A2UIServiceListSurfaceFeedbackRequest, options?: RpcOptions): UnaryCall<A2UIServiceListSurfaceFeedbackRequest, A2UIServiceListSurfaceFeedbackResponse>;
}
/**
 * A2UIService provides operations for A2UI surfaces.
 *
 * @generated from protobuf service c1.api.a2ui.v1.A2UIService
 */
export class A2UIServiceClient implements IA2UIServiceClient, ServiceInfo {
    typeName = A2UIService.typeName;
    methods = A2UIService.methods;
    options = A2UIService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * SubmitAction handles user actions on A2UI surfaces.
     *
     * @generated from protobuf rpc: SubmitAction
     */
    submitAction(input: A2UIServiceSubmitActionRequest, options?: RpcOptions): UnaryCall<A2UIServiceSubmitActionRequest, A2UIServiceSubmitActionResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<A2UIServiceSubmitActionRequest, A2UIServiceSubmitActionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListSurfaces returns active surfaces for a conversation.
     *
     * @generated from protobuf rpc: ListSurfaces
     */
    listSurfaces(input: A2UIServiceListSurfacesRequest, options?: RpcOptions): UnaryCall<A2UIServiceListSurfacesRequest, A2UIServiceListSurfacesResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<A2UIServiceListSurfacesRequest, A2UIServiceListSurfacesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * CreateSurfaceFeedback submits feedback for a surface with a snapshot.
     *
     * @generated from protobuf rpc: CreateSurfaceFeedback
     */
    createSurfaceFeedback(input: A2UIServiceCreateSurfaceFeedbackRequest, options?: RpcOptions): UnaryCall<A2UIServiceCreateSurfaceFeedbackRequest, A2UIServiceCreateSurfaceFeedbackResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<A2UIServiceCreateSurfaceFeedbackRequest, A2UIServiceCreateSurfaceFeedbackResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListSurfaceFeedback lists feedback for a surface.
     *
     * @generated from protobuf rpc: ListSurfaceFeedback
     */
    listSurfaceFeedback(input: A2UIServiceListSurfaceFeedbackRequest, options?: RpcOptions): UnaryCall<A2UIServiceListSurfaceFeedbackRequest, A2UIServiceListSurfaceFeedbackResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<A2UIServiceListSurfaceFeedbackRequest, A2UIServiceListSurfaceFeedbackResponse>("unary", this._transport, method, opt, input);
    }
}
